const translations = {
    clientNameFieldPlaceholder: 'Client',
    farmNameFieldPlaceholder: 'Farm',
    fieldNameFieldPlaceholder: 'Field',
    incompleteSelectionWarning:
        'Incomplete selection will not be stored. Please complete Client, Farm, and Field selections.',
    label: 'Client | Farm | Field'
};

export default translations;
